
export interface AdditionChargeVesselEntity {
    chargeOnCompany: string | null,
    billToCompany: string | null,
    consortiumCode: string | null,
    vesselCode: string | null,
    voyageCode: string | null,
    vesselName: string | null,
    etb: Date | null,
    etd: Date | null,
    serviceCode: string | null,
    slVesselCode: string | null,
    slIbVoyageCode: string | null,
    slObVoyageCode: string | null,
    soa: string | null,
    loa: number | null,
    operatingTml: string | null,

    [key: string]: string | number | Date | null | undefined | boolean
}

export const EMPTY_ADDITIONAL_CHARGE_VESSEL_ENTITY: AdditionChargeVesselEntity = {
    chargeOnCompany: null,
    billToCompany: null,
    consortiumCode: null,
    vesselCode: null,
    voyageCode: null,
    vesselName: null,
    etb: null,
    etd: null,
    serviceCode: null,
    slVesselCode: null,
    slIbVoyageCode: null,
    slObVoyageCode: null,
    soa: null,
    loa: null,
    operatingTml: null,

}

